import { render, staticRenderFns } from "./MasterPositionDepartment.vue?vue&type=template&id=c94d4e70&scoped=true"
import script from "./MasterPositionDepartment.vue?vue&type=script&lang=js"
export * from "./MasterPositionDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94d4e70",
  null
  
)

export default component.exports